import { render } from "./Aggregator.vue?vue&type=template&id=0497eb56&ts=true"
import script from "./Aggregator.vue?vue&type=script&lang=ts"
export * from "./Aggregator.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__